import React from 'react'

const Alert = (props) => {
  const { message, type } = props

  return (
    <div className={`alert alert-${type}`}>
      {message}
    </div>
  )
}

Alert.defaultProps = {
  message: '',
  type: 'info'
}

Alert.propTypes = {
  message: React.PropTypes.string,
  type: React.PropTypes.string,
}

export default Alert



// WEBPACK FOOTER //
// ./src/browser/components/Alert.js